export default "__VITE_ASSET__e2035254__"